@import '../../../globals/main.scss';

pn-find-service-and-price {
  .findprice-form {
    max-width: 50em;
    margin: 0 auto;
  }

  h2,
  .heading {
    text-align: center;
    font-size: 1.5em;
    line-height: 1.1;
    font-weight: bold;
    margin-bottom: 1rem;
  }
  .postagetypes,
  .deliveryscope {
    text-align: center;
    margin-bottom: 3rem;
  }

  .weightoption {
    display: flex;
    gap: 1em;
  }

  .weightoption-input {
    width: 5em;
    position: relative;

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }

  .weightoption-input-abbreviation {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 1.2em;
    margin-top: 1.55rem;
    font-weight: 500;
  }

  .weightoption-range {
    flex-grow: 1;
    align-self: flex-end;
    position: relative;
    top: 0.5em;
    input {
      width: calc(100% - 1.5em);
    }
    datalist {
      width: 100%;
      display: flex;
      justify-content: space-between;
      font-size: 0.75em;
    }
  }

  .resultlist {
    margin: 3em 0;
  }
}
